import { createAction } from '@reduxjs/toolkit';
import { GET_DICTIONARIES_SKILLS } from '../actionConstants';

export const getAllSkillsAction = createAction(GET_DICTIONARIES_SKILLS);
